export const account = {

    // --- My account (new settings screen: menu.vue + AccountWelcome.vue) ---
    mc_title: `Mon compte`,
    mc_subtitle: `Les paramètres de votre compte et de votre entreprise`,
    mc_group_account: `Compte`,
    mc_home: `Accueil`,
    mc_mydata: `Mes informations`,
    mc_subscription: `Abonnement`,
    mc_billing: `Facturation électronique`,
    mc_whatsapp: `WhatsApp Business`,
    mc_notifications: `Notifications`,
    mc_team: `Gestion de l'équipe`,
    mc_team_badge: `Nouveau`,
    mc_integrations: `Intégrations`,
    mc_hello: `Bonjour`,
    mc_welcome_sub: `Bienvenue sur votre compte. D'ici, vous gérez les informations de votre entreprise et les paramètres que le système utilise pour travailler pour vous.`,
    mc_quick: `Accès rapide`,
    mc_card_account_title: `Paramètres du compte`,
    mc_card_account_desc: `Coordonnées, langue du panneau et sécurité.`,
    mc_card_subscription_desc: `Votre forfait et la facturation de votre abonnement.`,
    mc_card_billing_desc: `Émetteurs fiscaux et quel émetteur facture chaque établissement.`,
    mc_card_whatsapp_desc: `La connexion que le système utilise pour communiquer avec vos voyageurs.`,
    mc_card_notifications_desc: `Les alertes que vous recevez et par quels canaux.`,
    mc_card_team_desc: `Invitez des collaborateurs et gérez leurs autorisations.`,
    mc_card_integrations_desc: `Connexions avec des services externes.`,

  p1: `Gérez votre compte`,
  p2: `Paramètres du compte`,
  p3: `Langue`,
  p4: `Connexion et sécurité`,
  p5: `Mon abonnement`,
  p6: `Informations de facturation`,
  p7: `WhatsApp Business`,
  p8: `Intégrations`,
  p9: `Paramètres du compte`,
  p10: `Gérez les coordonnées auxquelles vous recevrez toutes les communications de WACheckin.`,
  p11: `Données mises à jour avec succès`,
  p12: `Langue de la plateforme`,
  p13: `Sélectionnez la langue de votre choix pour votre panneau de contrôle. Ce paramètre n'affecte pas la langue du check-in que reçoivent vos voyageurs, car celle-ci dépend des réglages de leur appareil.`,
  p14: `Sélectionnez la langue dans la liste`,
  p15: `Sélectionner la langue`,
  p16: `Espagnol`,
  p17: `Anglais`,
  p18: `Mettre à jour la langue`,
  p19: `Langue appliquée avec succès`,
  p20: `Ici, vous pouvez mettre à jour votre mot de passe pour garder votre compte sécurisé.`,
  p21: `Souhaitez-vous changer votre mot de passe ?`,
  p22: `Changer le mot de passe`,
  p23: `Consultez votre e-mail`,
  p24: `Pour poursuivre le changement de mot de passe, consultez votre boîte de réception et suivez les étapes`,
  p25: `Continuer`,
  p26: `Oups ! Une erreur inattendue s'est produite`,
  p27: `Données mises à jour avec succès`,
  p28: `WhatsApp for Business`,
  p29: `Connectez votre compte WhatsApp Business à notre plateforme et envoyez des messages directement à vos voyageurs depuis votre numéro personnalisé.`,
  p30: `Aucun compte connecté.`,
  p31: `Connecter le compte`,
  p32: `Compte`,
  p33: `Connecté`,
  p34: `Déconnecter le compte`,
  p35: `Chargement des informations...`,
  p36: `Déconnecter WhatsApp for Business`,
  p37: `Envisagez-vous de déconnecter WhatsApp for Business et de cesser d'envoyer des messages à vos voyageurs via WhatsApp ?`,
  p38: `Déconnecter`,
  p39: `Compte WhatsApp Business déconnecté avec succès`,
  p40: `Impossible de déconnecter le compte WhatsApp Business, veuillez contacter le support`,
  p41: `Numéro de téléphone`,
  p42: `Compte Facebook`,
  p43: `Informations de l'entreprise`,
  p44: `Vous devez disposer d'un numéro de téléphone valide et unique pour l'utiliser avec l'API WhatsApp Business.`,
  p45: `Vous recevrez un code de vérification pour authentifier votre numéro sur notre plateforme.`,
  p46: `Votre numéro de téléphone professionnel doit être un numéro valide qui répond aux critères de la`,
  p47: `plateforme WhatsApp for Business.`,
  p48: `Vous recevrez un code de vérification pour authentifier votre numéro sur notre plateforme.`,
  p49: `Revenir à l'état du compte`,
  p50: `Continuer`,
  p51: `Vous devez disposer d'un compte Facebook personnel (lié à votre e-mail professionnel)`,
  p52: `Si vous avez créé et connecté un compte Facebook Business à ce système, vous devez l'authentifier avant de commencer le processus d'intégration en cliquant sur Se connecter avec Facebook.`,
  p53: `Pour authentifier votre compte professionnel, ouvrez`,
  p54: `ce lien`,
  p55: `dans un onglet séparé.`,
  p56: `Vous devez générer un code dans votre application d'authentification et le saisir dans le champ « Saisir le code ».`,
  p57: `Une fois confirmé, vous pouvez fermer cet onglet.`,
  p58: `Revenir à l'état du compte`,
  p59: `Retour`,
  p60: `Continuer`,
  p61: `Préparez les informations de votre entreprise`,
  p62: `Vous devez avoir sous la main les informations de votre entreprise : la raison sociale et l'adresse de votre société, ainsi que le compte professionnel tel que vous souhaitez qu'il s'affiche.`,
  p63: `Vous devez disposer d'un site web professionnel valide.`,
  p64: `Vous devez vérifier votre compte auprès de Meta dès que possible. Une entreprise vérifiée peut commencer par envoyer 1000 messages par jour. Si vous ne vérifiez pas votre compte, Meta le désactivera.`,
  p65: `Selon la politique de Meta, un compte professionnel non vérifié ne peut être lié qu'à deux numéros. Vérifiez le compte pour le lier à davantage de numéros.`,
  p66: `Revenir à l'état du compte`,
  p67: `Retour`,
  p68: `Continuer`,
  p69: `Compte WhatsApp Business connecté avec succès`,

  p70: `Facturation`,
  p71: `Statut`,
  p72: `Montant facturé`,
  p73: `Payé`,
  p74: `En attente`,
  p75: `Voir la facture`,
  p76: `Aucun enregistrement de facturation trouvé`,
  p77:`Date`,
  p78: ``,
  p79: ``,
  p80: ``,
};
